import './App.css';
import { Routes, Route } from "react-router-dom";
import Footer from './Components/footer/Footer';
import ScrollToTop from './Components/ScrollToTop';
import Home from './Pages/Home';
import Header from './Components/header/Header';
import WhatWe from './Pages/WhatWe';
import TheCorridor from './Pages/TheCorridor';
import OurNetwork from './Pages/OurNetwork';
import WhyWeExist from './Pages/WhyWeExist';
import Contact from './Pages/Contact';
import { ToastContainer } from 'react-toastify';
import TermsandCondition from './Pages/TermsandCondition';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import ReportDetail from './Pages/ReportDetail';
import Rimland from './Pages/Rimland';
import Subscription from './Pages/Subscription';
import TitleManager from './TitleManager';

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
       <TitleManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/what-we-do" element={<WhatWe />} />
        <Route path="/Insights" element={<TheCorridor />} />
        {/* <Route path="/our-network" element={<OurNetwork />} /> */}
        <Route path="/About" element={<WhyWeExist />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/terms-condition" element={<TermsandCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/ReportDetail/:id" element={<ReportDetail />} />
        <Route path="/subscription" element={<Subscription />} />
        {/* <Route path="/rimland" element={<Rimland />} /> */}
      </Routes>
      <Footer />
      <ToastContainer />
    </>
  );
}

export default App;
